define('modules/lp_leads/collections/leads',['require','exports','module','base/collection','../models/lead','env'],function(require, exports, module) {

  var BaseCollection = require("base/collection"),
      Lead = require("../models/lead"),
      config = require("env");

  module.exports = BaseCollection.extend({
    initialize: function(models, options){
      this.landingId = options.id;
      this.listenTo(this, "sync", this.onSync);
      this.page = options.page || 1;
      this.pageSize = options.pageSize !== undefined ? options.pageSize : 10;
      this.itemCount = 0;
      this.pageCount = 0;
      this.loaded = false;
    },
    model: Lead,
    url: function() {
      return [config.apiHost, "pages", this.landingId, "leads"].join("/") + "?page=" + this.page + "&items=" + this.pageSize;
    },
    onSync: function(collection, response, options){
      this.loaded = true;
      this.itemCount = parseInt(options.xhr.getResponseHeader("X-TotalItemCount") || 0);
      this.pageCount = Math.ceil(this.itemCount / this.pageSize);
      this.trigger("pager:itemcount", this.itemCount);
      this.trigger("pager:pagecount", this.pageCount);
    },
    fetchFirstPage: function(){
      this.page = 1;
      this.fetch({reset: true});
    },
    fetchPreviousPage: function(){
      if(this.page > 1){
        this.page--;
        this.fetch({reset:true});
      }
    },
    fetchPage: function(page){
      this.page = page || 1;
      this.fetch({reset:true});
    },
    fetchNextPage: function(){
      if(this.page < this.pageCount){
        this.page++;
        this.fetch({reset:true});
      }
    },
    fetchLastPage: function(){
      this.page = this.pageCount;
      this.fetch({reset: true});
    }
  });

});

